/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
import React from 'react';
import { Button, ButtonToolbar, Input, Modal, ModalBody } from 'reactstrap';
import { Dots } from "react-activity";
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';

import { copyToClipboard, isRUTValid, validateEmail, validatePhone } from '../../../helper/functions';

const ModalGeneratePass = (props) => {
  const {
    // functions
    handleFindContactData,
    handleGeneratePass,
    handleUpdatePhone,
    handleUpdateEmail,
    setContactData,
    toggle,
    // variables
    contactDataToUpdate,
    updatedContactData,
    contactData,
    loading,
    values,
  } = props;

  const dataValidation = contactData.entry === null ||
    !isRUTValid(contactDataToUpdate.rut) ||
    contactData.loading || updatedContactData.loading;

  return (
    <div>
      <Modal
        isOpen={values.isOpenModalGP}
        toggle={toggle}
        className="modal-dialog modal-dialog--header cntc-modal-generate"
      >
        <div className="modal__header">
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
          <h2 className="bold-text label_autofin  modal__title" style={{ fontWeight: 'bold' }}> <strong>Datos Portal Cliente</strong></h2>
        </div>
        <form className="form form--horizontal">
          <ModalBody>
            <div className='crm-modal-container'>
              <div className='crm-modal-group'>
                <div className='crm-modal-input'>
                  <label htmlFor='rut'>Ingrese RUT</label>
                  <Input
                    type="text"
                    name="rut"
                    id="rut"
                    value={contactDataToUpdate.rut}
                    onChange={(e) => {
                      setContactData({
                        ...contactDataToUpdate,
                        rut: e.target?.value,
                        phone: contactDataToUpdate.phone || '',
                        mail: contactDataToUpdate.mail || '',
                        pass: contactDataToUpdate.pass || '',
                      })
                    }}
                    invalid={!isRUTValid(contactDataToUpdate.rut)}
                    maxLength={13}
                    disabled={values._id}
                  />
                </div>
                <button
                  type='button'
                  className='crm-modal-black-btn'
                  onClick={handleFindContactData}
                  disabled={contactData.loading || !isRUTValid(contactDataToUpdate.rut) || contactDataToUpdate.rut.length === 0}
                >
                  {contactData.loading ? <Dots /> : 'Buscar'}
                </button>
              </div>
              <div className='crm-modal-group'>
                <div className='crm-modal-input'>
                  <label htmlFor='phone'>Teléfono</label>
                  <div className='crm-modal-phone-group'>
                    <Input
                      className='crm-modal-prefix-phone'
                      type='text'
                      value={'+56'}
                      disabled={true}
                    />
                    <Input
                      className='crm-modal-phone-number'
                      type="text"
                      name="phone"
                      id="phone"
                      value={contactDataToUpdate.phone}
                      onChange={(e) => setContactData({ ...contactDataToUpdate, phone: e.target.value })}
                      disabled={dataValidation || !contactDataToUpdate.exists}
                      invalid={!validatePhone(contactDataToUpdate.phone)}
                      maxLength={9}
                    />
                  </div>
                </div>
                <button
                  className='crm-modal-black-btn'
                  type='button'
                  disabled={dataValidation || !validatePhone(contactDataToUpdate.phone) || !contactDataToUpdate.phone?.length}
                  onClick={() => handleUpdatePhone(contactDataToUpdate)}
                >
                  {updatedContactData.loading ? <Dots /> : 'Guardar'}
                </button>
              </div>
              <div className='crm-modal-group'>
                <div className='crm-modal-input'>
                  <label htmlFor='email'>Correo</label>
                  <Input
                    type="text"
                    name="email"
                    id="email"
                    value={contactDataToUpdate.mail}
                    onChange={(e) => setContactData({ ...contactDataToUpdate, mail: e.target.value })}
                    disabled={dataValidation || !contactDataToUpdate.exists}
                    invalid={!validateEmail(contactDataToUpdate.mail)}
                    maxLength={100}
                  />
                </div>
                <button
                  className='crm-modal-black-btn'
                  type='button'
                  disabled={dataValidation || !validateEmail(contactDataToUpdate.mail) || !contactDataToUpdate.mail?.length}
                  onClick={() => handleUpdateEmail(contactDataToUpdate)}
                >
                  {updatedContactData.loading ? <Dots /> : 'Guardar'}
                </button>
              </div>
              <div className='crm-modal-generate-container'>
                <button
                  className='crm-modal-black-btn'
                  onClick={handleGeneratePass}
                  disabled={loading || (!isRUTValid(contactDataToUpdate.rut) || contactDataToUpdate.rut?.length < 8)}
                >
                  {loading ? <Dots /> : 'Generar Contraseña'}
                </button>
                <Tippy content="Click para copiar contraseña" placement='bottom' disabled={!contactDataToUpdate.pass}>
                  <button
                    type='button'
                    className={`crm-modal-generated-pass ${!contactDataToUpdate.pass && 'crm-modal-generated-pass-disabled'}`}
                    onClick={() => copyToClipboard(contactDataToUpdate?.pass || '')}
                  >
                    {contactDataToUpdate.pass || 'Genere Contraseña'}
                  </button>
                </Tippy>
              </div>
            </div>
          </ModalBody>
          <ButtonToolbar className="modal__footer">
            <Button className="cancel" onClick={toggle}>Cancelar</Button>
          </ButtonToolbar>
        </form>
      </Modal>
    </div>
  );
}

ModalGeneratePass.propTypes = {
  // functions
  handleFindContactData: PropTypes.func,
  handleGeneratePass: PropTypes.func,
  handleUpdatePhone: PropTypes.func,
  handleUpdateEmail: PropTypes.func,
  setContactData: PropTypes.func,
  toggle: PropTypes.func,

  // variables
  contactDataToUpdate: PropTypes.shape({
    rut: PropTypes.string,
    phone: PropTypes.string,
    mail: PropTypes.string,
    pass: PropTypes.string,
    exists: PropTypes.bool,
  }),

  updatedContactData: PropTypes.shape({
    loading: PropTypes.bool,
  }),

  contactData: PropTypes.shape({
    entry: PropTypes.any, // Puede ser null u otro tipo de dato, depende del contexto
    loading: PropTypes.bool,
  }),

  loading: PropTypes.bool,

  values: PropTypes.shape({
    isOpenModalGP: PropTypes.bool,
    _id: PropTypes.string, // Puede ser opcional si no siempre tiene valor
  }),
};

export default ModalGeneratePass;